export class Order {
    constructor () {
        this.id = "";
        this.user_id = "";
        this.file_id = "";
        this.side = "";
        this.sender_name = 0;
        this.sender_acc = "";
        this.remitte_name = "";
        this.remitte_acc = "";
        this.remitte_tel = "";
        this.sum = 0;
    }
}


// WEBPACK FOOTER //
// ./src/models/Order.js